import { put, takeLatest } from "redux-saga/effects";

import {
  fetchSupplementaryBillsListRequest,
  fetchSupplementaryBillsListSuccess,
  fetchSupplementaryBillsListFailure,
  SupplementaryBillsCreateRequest,
  SupplementaryBillsCreateSuccess,
  SupplementaryBillsCreateFailure,
  SupplementaryBillsUpdateRequest,
  SupplementaryBillsUpdateSuccess,
  SupplementaryBillsUpdateFaliure,
  SupplementaryBillsDeleteRequest,
  SupplementaryBillsDeleteSuccess,
  SupplementaryBillsDeleteFaliure,
  supplementaryBillsReportUpdateStatusRequest,
  supplementaryBillsReportUpdateStatusSuccess,
  supplementaryBillsReportUpdateStatusFailure,
  fetchSupplementaryBillsByIdRequest,
  fetchSupplementaryBillsByIdSuccess,
  fetchSupplementaryBillsByIdFailure
} from "redux/reducers/acclgl/supplementary-bills";
import {
  requestSupplementaryBillsList,
  requestSupplementaryBillsCreate,
  requestSupplementaryBillsUpdate,
  requestSupplementaryBillsDelete,
  requestSupplementaryBillsReportUpdateStatus,
  requestGetByIdSupplementaryBills
} from "services/acclgl/supplementarybills";
export function* watchsupplementarybills() {
  yield takeLatest(
    fetchSupplementaryBillsListRequest,
    fetchsupplementarybillslist
  );
  yield takeLatest(SupplementaryBillsCreateRequest, supplementarybillscreate);
  yield takeLatest(SupplementaryBillsUpdateRequest, supplementarybillsupdate);
  yield takeLatest(SupplementaryBillsDeleteRequest, supplementarybillsdelete);
  yield takeLatest(supplementaryBillsReportUpdateStatusRequest, supplementarybillsreportupdatestatus);
  yield takeLatest(fetchSupplementaryBillsByIdRequest, fetchSupplementaryBillsById);
}

function* fetchsupplementarybillslist({ payload }) {
  try {
    const response = yield requestSupplementaryBillsList(payload);
    yield put(fetchSupplementaryBillsListSuccess(response));
  } catch (error) {
    yield put(fetchSupplementaryBillsListFailure("Failed to get list"));
  }
}
function* supplementarybillscreate({ payload }) {
  try {
    const response = yield requestSupplementaryBillsCreate(payload);
    yield put(SupplementaryBillsCreateSuccess(response.data));
  } catch (error) {
    yield put(
      SupplementaryBillsCreateFailure("Failed to create Supplementary Bills")
    );
  }
}
function* supplementarybillsupdate({ payload }) {
  try {
    const response = yield requestSupplementaryBillsUpdate(payload);
    yield put(SupplementaryBillsUpdateSuccess(response.data));
  } catch (error) {
    yield put(
      SupplementaryBillsUpdateFaliure(
        "Failed to get update Supplementary Bills"
      )
    );
  }
}
function* supplementarybillsdelete({ payload }) {
  try {
    const response = yield requestSupplementaryBillsDelete(payload);
    yield put(SupplementaryBillsDeleteSuccess(response));
  } catch (error) {
    yield put(
      SupplementaryBillsDeleteFaliure("Failed to Delete Supplementary Bills")
    );
  }
}
function* supplementarybillsreportupdatestatus({ payload }) {
  try {
    const response = yield requestSupplementaryBillsReportUpdateStatus(payload);
    yield put(supplementaryBillsReportUpdateStatusSuccess(response));
    // yield put(supplementaryBillsReportUpdateStatusSuccess(response.data));
  } catch (error) {
    yield put(supplementaryBillsReportUpdateStatusFailure("Failed to Update list"));
  }
}

function* fetchSupplementaryBillsById({ payload }) {
  try {
    const response = yield requestGetByIdSupplementaryBills(payload);
    yield put(fetchSupplementaryBillsByIdSuccess(response));
  } catch (error) {
    yield put(fetchSupplementaryBillsByIdFailure("Failed to get Supplementary Bill data"));
  }
}
